export interface Film {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  region: string;
  duration: number;
  categories: string[];
  director: string;
  cast: string[];
  rating: number;
  tags: string[];
  summary: string;
  synopsis: string;
  views: number;
  releaseDate: string;
  cover: string;
  featured?: boolean;
}

export const CATEGORY_META = [
  {
    slug: "drama",
    name: "剧情",
    icon: "ri-book-open-line",
    desc: "以人物关系与叙事张力为核心的欧美成人剧情长片，强调剧本完成度、表演与摄影质感。",
  },
  {
    slug: "romance",
    name: "爱情",
    icon: "ri-heart-3-line",
    desc: "从浪漫邂逅到情感纠葛的欧美成人爱情作品，注重氛围营造与情绪递进。",
  },
  {
    slug: "action",
    name: "动作",
    icon: "ri-flashlight-line",
    desc: "融合特工、公路与冒险元素的欧美成人动作类影片，节奏明快、场面调度精准。",
  },
  {
    slug: "thriller",
    name: "悬疑",
    icon: "ri-eye-line",
    desc: "以反转结构与心理博弈见长的欧美成人悬疑片，适合喜欢层层推进叙事的观众。",
  },
  {
    slug: "literary",
    name: "文艺",
    icon: "ri-film-line",
    desc: "欧洲作者电影风格浓郁的成人作品，长镜头、自然光与留白是其典型语言。",
  },
  {
    slug: "series",
    name: "剧集",
    icon: "ri-play-list-2-line",
    desc: "分集叙事的欧美成人剧集，角色弧光完整，适合连续追看。",
  },
] as const;

export const REGIONS = ["美国", "英国", "法国", "意大利", "西班牙", "德国", "瑞典", "加拿大"];

export const YEARS = [2026, 2025, 2024, 2023, 2022, 2021];

export const ACTOR_TAGS = [
  "玛戈·德拉克洛瓦",
  "伊莎贝尔·罗西",
  "李奥·贝内特",
  "卡罗琳·薇拉",
  "阿尔贝托·莫雷蒂",
  "娜塔莉·索恩",
  "朱利安·勒鲁瓦",
  "艾玛·林德",
];

export const FEATURED_FILMS: Film[] = [
  {
    id: "midnight-paris",
    title: "巴黎午夜叙事",
    titleEn: "Midnight Narratives of Paris",
    year: 2026,
    region: "法国",
    duration: 128,
    categories: ["drama", "romance"],
    director: "让-皮埃尔·瓦莱",
    cast: ["玛戈·德拉克洛瓦", "朱利安·勒鲁瓦", "卡罗琳·薇拉"],
    rating: 8.7,
    tags: ["作者电影", "长镜头", "巴黎"],
    summary: "一位剧作家在塞纳河左岸的旧书店里，遇见了改变她整个剧本结构的人。",
    synopsis:
      "剧作家艾莲娜为了完成搁置三年的剧本，独自搬到巴黎左岸一间老公寓。她在深夜的旧书店里认识了爵士乐手卢卡，两个人的交谈逐渐从文学、电影延伸到各自最难启齿的过去。影片用近乎纪录的镜头语言记录下这段只持续了十一夜的相遇，把城市、时间与创作焦虑编织成一条缓慢下沉的情绪线。导演让-皮埃尔·瓦莱延续他一贯的自然光摄影与长镜头调度，把两人的每一次沉默都拍得比对话更响。",
    views: 128400,
    releaseDate: "2026-09-18",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20elegant%20woman%20in%20silk%20dress%20seen%20from%20behind%20silhouette%20near%20a%20rainy%20Paris%20window%20at%20midnight%2C%20warm%20golden%20lamplight%20and%20deep%20navy%20shadows%2C%20film%20grain%20texture%2C%20moody%20editorial%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-01&orientation=portrait",
    featured: true,
  },
  {
    id: "north-sea-lovers",
    title: "北海恋人",
    titleEn: "Lovers of the North Sea",
    year: 2025,
    region: "瑞典",
    duration: 112,
    categories: ["literary", "romance"],
    director: "艾玛·林德",
    cast: ["艾玛·林德", "娜塔莉·索恩", "李奥·贝内特"],
    rating: 8.4,
    tags: ["北欧", "海岛", "缓慢叙事"],
    summary: "北欧海岛上的两个陌生人在极昼里共度七天，谁都没有先说起自己的名字。",
    synopsis:
      "北欧某个只有四十七位居民的小岛上，来了一位拍摄海岸线的电影录音师，和一位整理遗物的钢琴调律师。极昼让夜晚从这七天里消失，两人约定不问彼此的身份与过去。影片以大量风声与环境音替代对白，用海岸线上的雾气推动情绪，是一部几乎全部发生在户外光线下的小品式作品。",
    views: 96400,
    releaseDate: "2025-11-02",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20two%20figures%20walking%20on%20a%20misty%20Nordic%20rocky%20coast%20at%20dusk%2C%20deep%20teal%20sea%20and%20pale%20grey%20sky%2C%20soft%20fog%2C%20muted%20desaturated%20tones%2C%20film%20grain%20texture%2C%20emotional%20cinematic%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-02&orientation=portrait",
    featured: true,
  },
  {
    id: "velvet-roman",
    title: "天鹅绒罗马",
    titleEn: "Velvet Rome",
    year: 2026,
    region: "意大利",
    duration: 136,
    categories: ["drama", "literary"],
    director: "阿尔贝托·莫雷蒂",
    cast: ["伊莎贝尔·罗西", "阿尔贝托·莫雷蒂", "卡罗琳·薇拉"],
    rating: 8.9,
    tags: ["意大利", "家族", "复古"],
    summary: "一个没落的罗马贵族家族，在最后一次宴会里揭开三代人共同守着的秘密。",
    synopsis:
      "罗马郊外一座即将被拍卖的庄园，家族成员为了签署售房协议而重聚。宴会从傍晚持续到黎明，旧照片、一卷未冲洗的胶片和一段被抹去的录音，让三代人的关系重新被摆上台面。影片在金色灯光与巨大阴影之间来回切换，是对意大利家族叙事的当代回应。",
    views: 154200,
    releaseDate: "2026-08-08",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20elegant%20woman%20in%20emerald%20velvet%20gown%20standing%20in%20a%20dim%20Roman%20villa%20ballroom%20with%20golden%20chandeliers%2C%20rich%20amber%20light%20and%20deep%20shadow%2C%20film%20grain%2C%20luxurious%20editorial%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-03&orientation=portrait",
    featured: true,
  },
  {
    id: "berlin-after-hours",
    title: "柏林凌晨三点",
    titleEn: "Berlin After Hours",
    year: 2025,
    region: "德国",
    duration: 104,
    categories: ["thriller", "drama"],
    director: "汉娜·克鲁格",
    cast: ["卡罗琳·薇拉", "李奥·贝内特"],
    rating: 8.1,
    tags: ["柏林", "夜行", "心理"],
    summary: "一位夜班电台主持人在凌晨三点的来电里，听到了自己被掩埋的过去。",
    synopsis:
      "柏林一家地下电台的主持人每夜直播到天亮。某个凌晨三点，一个自称听众的电话打进来，讲述了与她二十年前经历的同一件事，但细节全对而叙述者不对。接下来的四小时直播，她在调音台前试图找出对方的身份，同时控制住自己即将失控的声音。全片几乎只有一个场景，却始终保持着让人坐直身体的张力。",
    views: 88300,
    releaseDate: "2025-12-12",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20woman%20silhouette%20in%20a%20dim%20radio%20studio%20at%203am%2C%20glowing%20amber%20control%20panel%20lights%2C%20rain%20on%20window%2C%20deep%20navy%20and%20black%20tones%2C%20film%20grain%20texture%2C%20tense%20noir%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-04&orientation=portrait",
    featured: true,
  },
  {
    id: "coastline-89",
    title: "海岸公路 89",
    titleEn: "Coastline Route 89",
    year: 2026,
    region: "美国",
    duration: 118,
    categories: ["action", "romance"],
    director: "德文·马歇尔",
    cast: ["李奥·贝内特", "娜塔莉·索恩"],
    rating: 7.9,
    tags: ["公路", "加州", "追逃"],
    summary: "两个不该同行的人，开着一辆偷来的敞篷车沿加州一号公路向南。",
    synopsis:
      "修车厂技师在一次误会后被迫载着一位陌生女乘客南下。他们沿着一号公路穿过雾中的大桥、沙漠边的汽车旅馆与深夜的加油站，后座放着一个谁都没有打开的手提箱。影片把公路片的自由感与悬疑的压迫感叠在一起，追车段落克制而精准。",
    views: 112600,
    releaseDate: "2026-07-24",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20classic%20convertible%20car%20on%20a%20California%20coast%20highway%20at%20golden%20sunset%2C%20two%20figures%20silhouetted%2C%20warm%20orange%20sky%20and%20dark%20blue%20cliffs%2C%20film%20grain%2C%20wide%20cinematic%20composition%2C%20no%20text&width=900&height=1280&seq=film-cover-05&orientation=portrait",
    featured: true,
  },
];

export const FILMS: Film[] = [
  ...FEATURED_FILMS,
  {
    id: "london-grey",
    title: "伦敦灰调",
    titleEn: "London in Grey",
    year: 2024,
    region: "英国",
    duration: 121,
    categories: ["drama", "thriller"],
    director: "奥利弗·格兰特",
    cast: ["娜塔莉·索恩", "朱利安·勒鲁瓦"],
    rating: 8.2,
    tags: ["伦敦", "雨夜", "都市"],
    summary: "一位建筑摄影师在伦敦的灰调天气里，慢慢拼凑出一段被所有人否认的往事。",
    synopsis:
      "建筑摄影师受委托记录一栋即将拆除的工人住宅。在暗房里冲洗底片时，她发现同一扇窗户在二十年前的照片里出现过同一个身影。随着她对旧档案的追查，街区的记忆与自己的家庭史缠绕在一起。影片把伦敦的雨与灰调拍成了主角之一。",
    views: 74200,
    releaseDate: "2024-10-30",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20woman%20with%20a%20vintage%20camera%20in%20rainy%20grey%20London%20street%2C%20wet%20cobblestones%2C%20soft%20muted%20blue%20grey%20palette%2C%20film%20grain%20texture%2C%20melancholic%20editorial%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-06&orientation=portrait",
  },
  {
    id: "andalusian-summer",
    title: "安达卢西亚的夏天",
    titleEn: "Andalusian Summer",
    year: 2025,
    region: "西班牙",
    duration: 109,
    categories: ["romance", "literary"],
    director: "露西亚·费雷尔",
    cast: ["伊莎贝尔·罗西", "阿尔贝托·莫雷蒂"],
    rating: 8.5,
    tags: ["西班牙", "夏日", "南方"],
    summary: "南方小镇的整个夏天，两个人在白墙与橄榄树之间反复走近又退开。",
    synopsis:
      "在安达卢西亚一个夏天几乎没有空调的小镇，舞蹈老师与返乡的建筑学徒每天在同一时间走过同一条石板路。白墙、百叶窗与午后的寂静构成了整部影片的空间语言。导演露西亚·费雷尔用大量自然光与近乎无声的长镜头，把暧昧拍成了一种温度。",
    views: 103900,
    releaseDate: "2025-08-15",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20Andalusian%20whitewashed%20village%20alley%20in%20harsh%20summer%20sunlight%2C%20two%20figures%20in%20linen%20clothing%2C%20warm%20terracotta%20and%20cream%20tones%2C%20olive%20trees%2C%20film%20grain%20texture%2C%20no%20text&width=900&height=1280&seq=film-cover-07&orientation=portrait",
  },
  {
    id: "new-york-radio",
    title: "纽约无线电",
    titleEn: "New York Radio",
    year: 2023,
    region: "美国",
    duration: 115,
    categories: ["drama", "series"],
    director: "德文·马歇尔",
    cast: ["李奥·贝内特", "玛戈·德拉克洛瓦"],
    rating: 7.8,
    tags: ["纽约", "音乐", "群像"],
    summary: "一家即将关停的独立电台，把六个陌生人的深夜连接在了一起。",
    synopsis:
      "纽约下城一家独立电台接到关停通知，最后一个月里，主持人们决定把整档节目交给听众。六位常驻听众的故事在深夜档中交错展开，从布鲁克林的琴行到皇后区的出租车。影片结构接近多线群像，收尾克制。",
    views: 61200,
    releaseDate: "2023-06-21",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20old%20independent%20radio%20station%20booth%20in%20New%20York%20at%20night%2C%20warm%20amber%20desk%20lamp%2C%20vinyl%20records%2C%20city%20lights%20through%20window%2C%20film%20grain%2C%20nostalgic%20moody%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-08&orientation=portrait",
  },
  {
    id: "cote-dazur",
    title: "蔚蓝海岸的第七日",
    titleEn: "The Seventh Day on the Cote d'Azur",
    year: 2026,
    region: "法国",
    duration: 126,
    categories: ["romance", "drama"],
    director: "让-皮埃尔·瓦莱",
    cast: ["玛戈·德拉克洛瓦", "卡罗琳·薇拉"],
    rating: 8.6,
    tags: ["南法", "海边", "假期"],
    summary: "一场持续七天的海边假期，让两个已婚的人重新定义了自己想要的生活。",
    synopsis:
      "七月的蔚蓝海岸，两对夫妇共享一栋别墅。第七天以前，没有人说过一句真话。影片以每日章节的形式推进，早餐桌上的沉默一次比一次长，直到海面起了风暴。摄影在蓝白之间保持极高的克制。",
    views: 138700,
    releaseDate: "2026-06-19",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20French%20riviera%20villa%20terrace%20overlooking%20deep%20teal%20sea%20at%20dusk%2C%20two%20elegant%20figures%20standing%20apart%2C%20pale%20blue%20and%20golden%20light%2C%20film%20grain%20texture%2C%20refined%20editorial%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-09&orientation=portrait",
  },
  {
    id: "manchester-factory",
    title: "曼彻斯特工厂",
    titleEn: "Manchester Factory",
    year: 2024,
    region: "英国",
    duration: 132,
    categories: ["drama", "literary"],
    director: "奥利弗·格兰特",
    cast: ["朱利安·勒鲁瓦", "娜塔莉·索恩"],
    rating: 8.3,
    tags: ["工业", "工人阶级", "年代"],
    summary: "一间纺织厂关停前的最后三个月，几代工人的生活同时被改写。",
    synopsis:
      "上世纪八十年代的曼彻斯特，一间纺织厂即将关闭。厂里的老技工、年轻女工与刚被派来的会计，三条线索在同一台机器旁交汇。影片在厂房里完成了大部分拍摄，用棉絮、蒸汽与机器的噪音还原了那个年代的呼吸感。",
    views: 52900,
    releaseDate: "2024-03-14",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20textile%20factory%20interior%20with%20dusty%20sunbeams%20through%20tall%20windows%2C%20workers%20silhouettes%20among%20machines%2C%20warm%20sepia%20and%20grey%20tones%2C%20film%20grain%2C%20documentary%20style%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-10&orientation=portrait",
  },
  {
    id: "swedish-winter",
    title: "斯德哥尔摩的冬夜",
    titleEn: "Winter Night in Stockholm",
    year: 2025,
    region: "瑞典",
    duration: 97,
    categories: ["thriller", "drama"],
    director: "艾玛·林德",
    cast: ["艾玛·林德", "卡罗琳·薇拉"],
    rating: 8.0,
    tags: ["北欧黑色", "雪夜", "调查"],
    summary: "一场大雪封住了整条街，也封住了一桩三十年前没有被立案的失踪案。",
    synopsis:
      "斯德哥尔摩的老城区在大雪中停摆。一位退休警探与一位犯罪学博士生被困在同一栋楼里，两人翻出三十年前的卷宗，发现所有的证词都指向同一间空置公寓。北欧黑片的冷峻在雪与昏黄街灯之间被推到极致。",
    views: 79500,
    releaseDate: "2025-01-29",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20snow%20covered%20Stockholm%20old%20town%20street%20at%20night%2C%20single%20figure%20under%20amber%20street%20lamp%2C%20deep%20blue%20snow%20and%20warm%20lantern%20light%2C%20film%20grain%2C%20nordic%20noir%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-11&orientation=portrait",
  },
  {
    id: "tuscan-vineyard",
    title: "托斯卡纳的午后",
    titleEn: "Afternoon in Tuscany",
    year: 2023,
    region: "意大利",
    duration: 108,
    categories: ["romance", "literary"],
    director: "阿尔贝托·莫雷蒂",
    cast: ["伊莎贝尔·罗西", "李奥·贝内特"],
    rating: 8.1,
    tags: ["酒庄", "乡村", "慢生活"],
    summary: "一位酿酒师与一位暂住的画者，在葡萄园的午后聊了许多年没说过的话。",
    synopsis:
      "托斯卡纳的一座家族酒庄在采收季节迎来一位暂住的画者。两人从修剪枝条聊到父亲的病，午后的光线成了他们之间唯一的计时工具。影片节奏极慢，却被影评人称为「本年度最温柔的作品」。",
    views: 68700,
    releaseDate: "2023-09-08",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20Tuscan%20vineyard%20rows%20in%20warm%20late%20afternoon%20light%2C%20stone%20farmhouse%2C%20two%20figures%20sitting%20under%20a%20cypress%2C%20golden%20olive%20tones%2C%20film%20grain%20texture%2C%20no%20text&width=900&height=1280&seq=film-cover-12&orientation=portrait",
  },
  {
    id: "lisbon-tiles",
    title: "里斯本蓝瓷",
    titleEn: "Lisbon Blue Tiles",
    year: 2026,
    region: "西班牙",
    duration: 102,
    categories: ["drama", "romance"],
    director: "露西亚·费雷尔",
    cast: ["娜塔莉·索恩", "阿尔贝托·莫雷蒂"],
    rating: 8.2,
    tags: ["里斯本", "手工艺", "城市"],
    summary: "修复一面旧瓷砖墙的三个月，让两个陌生人在同一栋楼里交换了人生。",
    synopsis:
      "里斯本的老楼里，一面破损的蓝色瓷砖墙成为两个租客共同的任务。修复的过程像是一场耐心的拆解：一层水泥、一段旧报纸、一张褪色的照片。影片以极小的事件撑起完整的情绪弧线。",
    views: 84600,
    releaseDate: "2026-04-10",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20woman%20restoring%20blue%20azulejo%20tiles%20on%20a%20Lisbon%20facade%2C%20warm%20afternoon%20light%20and%20cool%20indigo%20tiles%2C%20film%20grain%20texture%2C%20intimate%20editorial%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-13&orientation=portrait",
  },
  {
    id: "hamburg-night",
    title: "汉堡夜航",
    titleEn: "Hamburg Night Ferry",
    year: 2024,
    region: "德国",
    duration: 113,
    categories: ["action", "thriller"],
    director: "汉娜·克鲁格",
    cast: ["卡罗琳·薇拉", "朱利安·勒鲁瓦"],
    rating: 7.7,
    tags: ["港口", "追踪", "夜航"],
    summary: "一艘夜间渡轮上的单程航行，乘客名单里多了一个不该存在的人。",
    synopsis:
      "汉堡港的夜间渡轮只有四十分钟航程，却是这部电影全部的舞台。一位报关员在船上认出了名单外的乘客，接下来的航行变成了一场低烈度但持续的博弈。密闭空间调度与港口灯火的冷暖对比，是影片最鲜明的形式感。",
    views: 59100,
    releaseDate: "2024-11-16",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20night%20ferry%20deck%20on%20Hamburg%20harbor%2C%20lone%20figure%20at%20railing%2C%20container%20cranes%20with%20amber%20lights%2C%20deep%20teal%20water%2C%20film%20grain%20texture%2C%20atmospheric%20noir%20photography%2C%20no%20text&width=900&height=1280&seq=film-cover-14&orientation=portrait",
  },
  {
    id: "brooklyn-rooftop",
    title: "布鲁克林天台",
    titleEn: "Brooklyn Rooftop",
    year: 2025,
    region: "美国",
    duration: 99,
    categories: ["romance", "series"],
    director: "德文·马歇尔",
    cast: ["李奥·贝内特", "娜塔莉·索恩"],
    rating: 7.9,
    tags: ["纽约", "音乐", "剧集"],
    summary: "一栋布鲁克林公寓的天台上，四个人用整个夏天办完了他们的告别演出。",
    synopsis:
      "公寓即将被收回，天台上的简易舞台只剩一个夏天。四位乐队成员分散在城市各处，各自的生活正走向不同方向。剧集以每集一个主角的视角推进，最终在天台完成了一场没有观众的演出。",
    views: 70600,
    releaseDate: "2025-05-23",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20Brooklyn%20rooftop%20at%20golden%20hour%20with%20string%20lights%20and%20old%20drums%2C%20city%20skyline%20behind%2C%20warm%20amber%20and%20dusty%20rose%20tones%2C%20film%20grain%20texture%2C%20nostalgic%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-15&orientation=portrait",
  },
  {
    id: "edinburgh-letters",
    title: "爱丁堡来信",
    titleEn: "Letters from Edinburgh",
    year: 2022,
    region: "英国",
    duration: 124,
    categories: ["literary", "drama"],
    director: "奥利弗·格兰特",
    cast: ["玛戈·德拉克洛瓦", "朱利安·勒鲁瓦"],
    rating: 8.4,
    tags: ["书信", "旧城", "历史"],
    summary: "档案管理员在一批未寄出的信件里，读到了半座城的秘密。",
    synopsis:
      "爱丁堡的档案室因整修而暂时关闭，一位管理员获得了提前整理旧信件的权限。这些信从未寄出，却记录了旧城半个世纪的人际网络。电影以阅读与回忆的双线结构展开，文字与画面的呼应极为精确。",
    views: 47300,
    releaseDate: "2022-12-02",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20hands%20holding%20old%20handwritten%20letters%20in%20a%20dim%20Edinburgh%20archive%20room%2C%20faded%20paper%20and%20dusty%20light%20through%20gothic%20window%2C%20sepia%20and%20cool%20grey%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=1280&seq=film-cover-16&orientation=portrait",
  },
  {
    id: "milan-atelier",
    title: "米兰工作室",
    titleEn: "Milan Atelier",
    year: 2026,
    region: "意大利",
    duration: 117,
    categories: ["drama", "thriller"],
    director: "阿尔贝托·莫雷蒂",
    cast: ["伊莎贝尔·罗西", "玛戈·德拉克洛瓦"],
    rating: 8.0,
    tags: ["时尚", "密室", "行业"],
    summary: "时装工作室的闭门会议上，一份被改动的设计稿牵出了整季的秘密。",
    synopsis:
      "米兰一间高级时装工作室在发布会前三周接到匿名举报。设计稿、面料订单与前台记录拼出了一条完整的改动链。影片把行业内部的权力结构拍成了一场密室推理，冷静而锋利。",
    views: 91300,
    releaseDate: "2026-02-27",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20elegant%20fashion%20atelier%20in%20Milan%20with%20mannequins%20and%20fabric%20rolls%2C%20single%20woman%20reviewing%20sketches%20under%20warm%20spotlight%2C%20muted%20charcoal%20and%20gold%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=1280&seq=film-cover-17&orientation=portrait",
  },
  {
    id: "montreal-snow",
    title: "蒙特利尔雪线",
    titleEn: "Montreal Snowline",
    year: 2024,
    region: "加拿大",
    duration: 105,
    categories: ["thriller", "literary"],
    director: "克莱尔·杜布瓦",
    cast: ["娜塔莉·索恩", "艾玛·林德"],
    rating: 7.8,
    tags: ["加拿大", "冬季", "孤独"],
    summary: "除雪车司机在连续工作的第十六个小时，发现城里少了一条街。",
    synopsis:
      "蒙特利尔遭遇二十年一遇的暴雪，除雪车司机连续工作。在第十六个小时，他发现自己每天经过的那条街在地图上消失了。影片用极致的白与夜里的橙色车灯构建了一个关于疲惫与记忆的寓言。",
    views: 41800,
    releaseDate: "2024-01-19",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20orange%20snowplow%20lights%20in%20a%20heavy%20Montreal%20blizzard%20at%20night%2C%20empty%20white%20street%2C%20deep%20blue%20darkness%20and%20amber%20beams%2C%20film%20grain%20texture%2C%20minimal%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-18&orientation=portrait",
  },
  {
    id: "barcelona-gothic",
    title: "巴塞罗那哥特区",
    titleEn: "Gothic Quarter, Barcelona",
    year: 2025,
    region: "西班牙",
    duration: 111,
    categories: ["action", "drama"],
    director: "露西亚·费雷尔",
    cast: ["阿尔贝托·莫雷蒂", "卡罗琳·薇拉"],
    rating: 7.6,
    tags: ["巴塞罗那", "老城", "追逐"],
    summary: "一个送错地址的包裹，让哥特区的三条街同时陷入了混乱。",
    synopsis:
      "巴塞罗那哥特区的窄巷里，一个包裹被送进了错误的门牌。接下来四十八小时，三条街上的住户、店主与一位休假的警员都被卷进同一件事。影片用真实的窄巷空间完成了多段长镜头调度。",
    views: 55400,
    releaseDate: "2025-03-07",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20narrow%20Barcelona%20gothic%20quarter%20alley%20with%20warm%20lanterns%20and%20stone%20arches%2C%20figure%20running%20with%20a%20parcel%2C%20ochre%20stone%20and%20deep%20shadow%2C%20film%20grain%2C%20dynamic%20cinematography%2C%20no%20text&width=900&height=1280&seq=film-cover-19&orientation=portrait",
  },
  {
    id: "amsterdam-canals",
    title: "阿姆斯特丹运河纪事",
    titleEn: "Amsterdam Canal Chronicles",
    year: 2023,
    region: "德国",
    duration: 119,
    categories: ["series", "romance"],
    director: "汉娜·克鲁格",
    cast: ["艾玛·林德", "李奥·贝内特"],
    rating: 8.1,
    tags: ["运河", "剧集", "日常"],
    summary: "运河边的一间咖啡馆，记录了六个季节里进出门口的每一段故事。",
    synopsis:
      "阿姆斯特丹运河边的小咖啡馆只有九张桌子，却容纳了这座城市最多的秘密。剧集按季节分为六集，每一集以一位常客为视角，让同一个空间不断被重新定义。",
    views: 63800,
    releaseDate: "2023-04-14",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20cinematic%20movie%20poster%20style%20image%2C%20Amsterdam%20canal%20side%20cafe%20window%20at%20dusk%2C%20bicycles%20and%20bridge%20lights%20reflected%20in%20water%2C%20warm%20amber%20interior%20against%20cool%20blue%20evening%2C%20film%20grain%20texture%2C%20no%20text&width=900&height=1280&seq=film-cover-20&orientation=portrait",
  },
];

export const getFilmById = (id: string): Film | undefined => FILMS.find((film) => film.id === id);

export const getCategoryName = (slug: string): string =>
  CATEGORY_META.find((item) => item.slug === slug)?.name ?? slug;

export interface ActorProfile {
  name: string;
  role: string;
  avatar: string;
}

export const ACTOR_PROFILES: Record<string, ActorProfile> = {
  "玛戈·德拉克洛瓦": {
    name: "玛戈·德拉克洛瓦",
    role: "法国 · 电影与舞台双栖演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20European%20actress%20in%20her%20thirties%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20black%20and%20white%20style%20with%20warm%20tone%2C%20serene%20expression%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=actor-01&orientation=squarish",
  },
  "伊莎贝尔·罗西": {
    name: "伊莎贝尔·罗西",
    role: "意大利 · 作者电影常客",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Mediterranean%20European%20actress%20with%20dark%20hair%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20calm%20expression%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=actor-02&orientation=squarish",
  },
  "李奥·贝内特": {
    name: "李奥·贝内特",
    role: "美国 · 剧情与公路片演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20male%20European%20American%20actor%20in%20his%20thirties%20with%20short%20hair%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20thoughtful%20expression%2C%20no%20text&width=400&height=400&seq=actor-03&orientation=squarish",
  },
  "卡罗琳·薇拉": {
    name: "卡罗琳·薇拉",
    role: "德国 · 悬疑与舞台剧演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20blonde%20Northern%20European%20actress%20in%20her%20thirties%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20confident%20expression%2C%20no%20text&width=400&height=400&seq=actor-04&orientation=squarish",
  },
  "阿尔贝托·莫雷蒂": {
    name: "阿尔贝托·莫雷蒂",
    role: "意大利 · 导演与演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20older%20Italian%20gentleman%20actor%20with%20grey%20hair%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20dignified%20expression%2C%20no%20text&width=400&height=400&seq=actor-05&orientation=squarish",
  },
  "娜塔莉·索恩": {
    name: "娜塔莉·索恩",
    role: "英国 · 都市题材演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20British%20actress%20with%20auburn%20hair%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20warm%20expression%2C%20no%20text&width=400&height=400&seq=actor-06&orientation=squarish",
  },
  "朱利安·勒鲁瓦": {
    name: "朱利安·勒鲁瓦",
    role: "法国 · 电影与剧集演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20French%20male%20actor%20with%20dark%20curly%20hair%2C%20soft%20warm%20neutral%20background%2C%20subtle%20golden%20rim%20light%2C%20editorial%20portrait%20photography%2C%20introspective%20expression%2C%20no%20text&width=400&height=400&seq=actor-07&orientation=squarish",
  },
  "艾玛·林德": {
    name: "艾玛·林德",
    role: "瑞典 · 导演与演员",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Scandinavian%20woman%20director%20in%20her%20forties%2C%20pale%20cool%20neutral%20background%2C%20soft%20window%20light%2C%20editorial%20black%20and%20white%20portrait%20photography%2C%20calm%20expression%2C%20no%20text&width=400&height=400&seq=actor-08&orientation=squarish",
  },
};

export const HERO_POSTER =
  "https://readdy.ai/api/search-image?query=Cinematic%20dark%20navy%20theater%20atmosphere%20abstract%20background%2C%20elegant%20artistic%20composition%20with%20soft%20golden%20spotlight%20rays%2C%20deep%20indigo%20velvet%20curtain%20textures%2C%20subtle%20film%20grain%2C%20moody%20premium%20editorial%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-cinema-banner&orientation=landscape";